import * as React from "react";
import { focusManager } from "@tanstack/react-query";

/** Whether the page is visible — TanStack Query's own notion
 *  (``focusManager``: ``document.visibilityState``), so a loop gated on
 *  it pauses and resumes together with the queries' retries. */
export function usePageVisible(): boolean {
  return React.useSyncExternalStore(
    (onChange) => focusManager.subscribe(() => onChange()),
    () => focusManager.isFocused(),
  );
}

function subscribeOnline(onChange: () => void): () => void {
  window.addEventListener("online", onChange);
  window.addEventListener("offline", onChange);
  return () => {
    window.removeEventListener("online", onChange);
    window.removeEventListener("offline", onChange);
  };
}

/** ``false`` when the browser knows it has no network (``navigator.onLine``
 *  — reliable when false; ``true`` only means "maybe"). Then a failed
 *  request is the user's connection, not Repoworks restarting. */
export function useBrowserOnline(): boolean {
  return React.useSyncExternalStore(subscribeOnline, () => navigator.onLine);
}
